import { createSlice } from '@reduxjs/toolkit'

import client from 'api'
import { AppThunk } from 'store'
import { IxNotesModule } from 'enums/notes-module-enum'

export const notesModuleConfig = {
    [IxNotesModule.Meldung]: {
        tableName: 'nurismeldnotiz', 
        objectFieldName: 'MELDUNGID' 
    },
    [IxNotesModule.Auftrag]: {
        tableName: 'nurisauftnotiz', 
        objectFieldName: 'AUFTRAGGID' 
    },
    [IxNotesModule.TO]: {
        tableName: 'nuristonotiz', 
        objectFieldName: 'TOID' 
    }
}

const initialState = {
    module: IxNotesModule.Meldung, // Default module
    tableName: '',
    objectFieldName: '',
    objectId: 0,
    notes: [] as any[],
    hasError: false,
}

const notesSlice = createSlice({
    name: 'notes',
    initialState,
    reducers: {
        setNotes: (state, { payload }) => {
            state.hasError = false;
            state.module = payload.module
            state.objectId = payload.objectId
            state.notes = payload.notes
        },
        addNote: (state, action) => {
            state.hasError = false;
            if (Array.isArray(action.payload)) {
                state.notes = [...state.notes, ...action.payload]
            } else {
                state.notes = [...state.notes, action.payload]
            }
        },
        replaceNote: (state, action) => {
            state.hasError = false;
            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.notes.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.notes.push(updatedItem) }
                else { state.notes[i] = { ...state.notes[i], ...updatedItem } }
            }
        },
        setError: (state) => {
            state.hasError = true;
        }
    }
})

export const loadNotes = (module: IxNotesModule, objectId: number): AppThunk => async (dispatch) => {
    try {
        const config = notesModuleConfig[module]
        const res = await client.get(`/api/ixweb/${config.tableName}/?MIN_${config.objectFieldName}=${objectId}&MAX_${config.objectFieldName}=${objectId}`)
        
        dispatch(setNotes({
            module,
            objectId,
            notes: res.data
        }))
    } catch(e) {
        dispatch(setError())
    }
}

export const createNote = (module: IxNotesModule, note: any): AppThunk => async (dispatch, getState) => {
    try {
        const config = notesModuleConfig[module]
        note[config.objectFieldName] = getState().notes.objectId
        const res = await client.post(`/api/ixweb/${config.tableName}/`, note)

        const { notes } = getState()
        if (notes.objectId === note[config.objectFieldName]) {
            dispatch(addNote(res.data))
        }
    } catch (e) {
        dispatch(setError())
    }
}

export const updateNote = (module: IxNotesModule, note: any): AppThunk => async (dispatch, getState) => {
    try {
        const config = notesModuleConfig[module]
        const res = await client.put(`/api/ixweb/${config.tableName}/${note.HDR_ID}/`, note)

        const { notes } = getState()
        if (note[config.objectFieldName] === notes.objectId) {
            dispatch(replaceNote(res.data))
        }
    } catch(e) {
        dispatch(setError())
    }
}

export const deleteNote = (module: IxNotesModule, note: any): AppThunk => async (dispatch, getState) => {
    try {
        const config = notesModuleConfig[module]
        await client.delete(`/api/ixweb/${config.tableName}/${note.HDR_ID}/`)

        const { notes } = getState()
        if (note[config.objectFieldName] === notes.objectId) {
            dispatch(loadNotes(module, notes.objectId))
        }
    } catch(e) {
        dispatch(setError())
    }
}

export const { setNotes, addNote, replaceNote, setError } = notesSlice.actions
export default notesSlice.reducer
